import React from "react";

import { MessageCircle } from "lucide-react";

const EmptyState = ({ hasSearchInput }: EmptyStateProps) => {
  return (
    <div className="text-center py-12 text-gray-500 dark:text-gray-400">
      <MessageCircle size={48} className="mx-auto mb-4 opacity-50" />
      <h3 className="text-base font-medium mb-2">
        {hasSearchInput ? "No matching history found" : "No search history yet"}
      </h3>
      <p className="text-sm">
        {hasSearchInput
          ? "Try adjusting your search terms"
          : "Start a conversation to build your search history"}
      </p>
    </div>
  );
};

type EmptyStateProps = {
  hasSearchInput: boolean;
};

export default EmptyState;
